export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/web_analytics.2b8e6bd.svg";